// @flow

import { type Tenant } from '@tectonics/commons/tenant';
import { type IncomingPayment } from './types';
import { getPaymentFromApi } from './get-payment-from-api';
import { normalizeIncomingPayment } from './normalize';

export async function fetchIncomingPayment(hash: string, tenant: Tenant): Promise<IncomingPayment> {
  const rawIncomingPayment = await getPaymentFromApi(hash, tenant);
  return normalizeIncomingPayment(rawIncomingPayment);
}
